interface ToastProps {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: ToastProps) {
  return (
    <div
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-[60] px-5 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium transition-all duration-300 pointer-events-none ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <span className="flex items-center gap-2">
        <i className="ri-information-line"></i>
        {message}
      </span>
    </div>
  );
}